import React from "react";
import { Box, Flex, Text} from "@chakra-ui/react";
import Link from "../../../../components/Link";
import { TaskState } from "../../../../components/States";
import urlToId from "../../../../helpers/UrlToId";
import formatDate from "../../../../helpers/formatDate";
import formatDateTable from "../../../../helpers/FormatDateTable";
import Pagination from "../../../../components/pagination/Pagination";

export default function TaskListCardView({ includeFilters, tasks }) {
  const cardColor = "gray.200";
  const tableColor = "gray.700";
  return (
    <>
      {tasks.results.map((t) => (
        <Flex
          key={t.url}
          maxWidth={"500px"}
          width="100%"
          backgroundClip="border-box"
          bg={cardColor}
          borderColor={"gray:700"}
          borderWidth={2}
          borderBottomWidth={6}
          borderRadius="15px"
          p="1.5rem"
          my="1rem"
        >
          <Box display="flex" flexDirection="column" width="100%">
            <Link
              to={`/is-emri/${urlToId(t.ticket) || ""}?gorev=${
                urlToId(t.url) || ""
              }`}
            >
              <Text p={1} fontSize="md" fontWeight="bold">
                {t.title}
              </Text>
            </Link>
            <Text
              p={1}
              pl={0}
              color={tableColor}
              fontSize="sm"
              fontWeight="semibold"
            >
              Bayi:{" "}
              {t.assigned_to ? (
                <Link to="/abc/">{t.assigned_to.name}</Link>
              ) : (
                "--"
              )}
            </Text>
            <Text
              p={1}
              pl={0}
              color={tableColor}
              fontSize="sm"
              fontWeight="semibold"
            >
              Oluşturulma: {formatDate(t.created_at)}
            </Text>
            <Text
              p={1}
              pr={1}
              pl={0}
              color={tableColor}
              fontSize="sm"
              fontWeight="semibold"
            >
              Randevu:
              {t.appointment_date ? (
                <>
                  <Text pl={1} as="span">
                    {formatDateTable(t.appointment_date)}
                  </Text>{" "}
                  <Text as="span">
                    {t.appointment_start_time?.slice(0, -3)} -{" "}
                    {t.appointment_end_time?.slice(0, -3)}
                  </Text>
                </>
              ) : (
                "--"
              )}
            </Text>
            <Text
              p={1}
              pl={0}
              color={tableColor}
              fontSize="sm"
              fontWeight="semibold"
            >
              Durum: <TaskState state={t.state} />
            </Text>
            <Text
              p={1}
              pl={0}
              color={tableColor}
              fontSize="sm"
              fontWeight="semibold"
            >
              İlerleme Beklentisi:{" "}
              {t.deadline_ratio ? formatDate(t.deadline_at) : "--"}
            </Text>
          </Box>
        </Flex>
      ))}
      <Pagination
        path={"gorevler"}
        num_of_items={tasks.num_of_items}
        num_of_pages={tasks.num_of_pages}
        currentPage={tasks.current_page}
      />
    </>
  );
}
